import { type IResultsReducer } from '../../interface/IReducer';

export default function electionReducer(state = {} as IResultsReducer, action: { type: string; payload: any }) {
	return { ...state, [action.type]: action.payload };
}
